// Small reusable avatar. Renders the uploaded photo when a user has one,
// otherwise falls back to the deterministic role-colored initials chip.
// Feb 2026 — introduced so Locations, Employees, Team pages can render
// real faces once managers upload their photos.
import { avatarBg } from "@/lib/roleColors";

function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]?.toUpperCase()).join("");
}

export default function Avatar({
  user,
  size = 24,
  fontSize,
  ring = false,
  className = "",
  style = {},
  title,
  testid,
}) {
  const base = {
    width: size,
    height: size,
    ...style,
  };
  const ringClass = ring ? "ring-2 ring-[hsl(var(--surface))]" : "";
  if (user?.avatar_url) {
    return (
      <img
        src={user.avatar_url}
        alt={user.name || ""}
        title={title || user?.name}
        loading="lazy"
        className={`rounded-full object-cover shrink-0 ${ringClass} ${className}`}
        style={base}
        data-testid={testid}
      />
    );
  }
  const fs = fontSize || Math.max(9, Math.round(size * 0.42));
  return (
    <span
      title={title || user?.name}
      className={`rounded-full grid place-items-center text-white font-bold shrink-0 ${ringClass} ${className}`}
      style={{ ...base, background: avatarBg(user?.name || "?", user?.role || "employee"), fontSize: fs }}
      data-testid={testid}
    >
      {initials(user?.name || "?")}
    </span>
  );
}
